import { Col } from 'components/Col';
import { CustomTextField } from 'components/CustomTextField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { ChangeEvent, useContext, useMemo } from 'react';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.descricaoTurma;
export default function Turmas() {
  const { state, dispatch, validator } = useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'descricaoTurma',
        etapa: EtapaProjeto.infosIniciais,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  return (
    <Row>
      <Col>
        <CustomTextField
          label={language.label}
          placeholder={language.placeholder}
          name='descricaoTurma'
          value={state.projeto.descricaoTurma ?? ''}
          onChange={(evt: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: { descricaoTurma: evt.target.value },
            });
          }}
          counter={true}
          maxSize={200}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
